/**
 * Like native scroll
 * @author vidmantasz @ wix.com
 * @param container DOMNode
 * @param onScroll Function
 * @param belowHeader bool
 */
export default function initLNScroll(container, onScroll) {
  let diffRatio, decoHeight, maxTop;
  const deco = container.parentElement.appendChild(window.document.createElement('div'));
  deco.className = 'ln-scroll-deco';

  if (container.lmScrollInited) {
    return;
  }
  container.lmScrollInited = true;

  function fireOnScroll(scrollTop) {
    const scrolled = (scrollTop + 1) / (container.scrollHeight + 1 - container.offsetHeight);
    if (onScroll) {
      onScroll(scrollTop ? scrolled : 0, scrollTop);
    }
  }

  function handleScroll() {
    const scrollTop = container.scrollTop;
    setDecoScroll(scrollTop);
    fireOnScroll(scrollTop);
  }

  function initSizes() {
    diffRatio = container.scrollHeight / container.offsetHeight;
    decoHeight = container.offsetHeight / (container.scrollHeight / container.offsetHeight);
    maxTop = container.offsetHeight - decoHeight;

    setDecoScroll(container.scrollTop);
    deco.style.height = container.scrollHeight === decoHeight ? 0 : decoHeight + 'px';
  }

  function setDecoScroll(scrollTop) {
    const top = window.Math.min(maxTop, window.Math.max(0, scrollTop / diffRatio));
    deco.style.top = top + 'px';
  }


  initSizes();
  window.setInterval(initSizes, 1100);
  window.addEventListener('resize', initSizes);
  container.addEventListener('scroll', handleScroll, false);

  function getEventName(event) {
    const eventNames = {
      'mouse': {'start': 'mousedown', 'move': 'mousemove', 'end': 'mouseup'},
      'touch': {'start': 'touchstart', 'move': 'touchmove', 'end': 'touchend'}
    };
    const type = (event.type.indexOf('touch') !== -1) ? 'touch' : 'mouse';
    return eventNames[type];
  }

  function getEventY(event) {
    if (event.type.indexOf('touch') !== -1) {
      if (event.touches.length) {
        return event.touches[0].clientY;
      } else if (event.changedTouches.length) {
        return event.changedTouches[0].clientY;
      }
    } else {
      return event.clientY;
    }
  }

  function startMove(ev) {
    ev.preventDefault();
    startMove.startY = getEventY(ev);
    startMove.decoY = deco.offsetTop;
    const eventName = getEventName(ev);
    window.addEventListener(eventName.move, move, false);
    window.addEventListener(eventName.end, endMove, false);
  }

  function move(ev) {
    ev.preventDefault();
    let decoPos = startMove.decoY + getEventY(ev) - startMove.startY;
    decoPos = window.Math.min(maxTop, window.Math.max(0, decoPos));
    deco.style.top = decoPos + 'px';
    container.scrollTop = decoPos * diffRatio;
    fireOnScroll(container.scrollTop);
  }

  function endMove(ev) {
    const eventName = getEventName(ev);
    window.removeEventListener(eventName.move, move);
    window.removeEventListener(eventName.end, endMove);
  }

  deco.addEventListener('mousedown', startMove);
  deco.addEventListener('touchstart', startMove);

  return initSizes;
}



// WEBPACK FOOTER //
// ./services/ln-scroll.js